import { createGlobalStyle } from 'styled-components';
import variables from '../variables';

export const Styles = createGlobalStyle`
  :root{
    --transparentGrey: ${props =>
      props.theme === 'light'
        ? 'rgba(200,200,200,.25)'
        : 'rgba(120,120,120,.25)'};
    --transparentGrey-10: ${props =>
      props.theme === 'light'
        ? 'rgba(200,200,200,.55)'
        : 'rgba(150,150,150,.55)'};
    --transparentGrey-20: ${props =>
      props.theme === 'light'
        ? 'rgba(150,150,150,.55)'
        : 'rgba(150,150,150,.75)'};
    --transparentBackground-10:rgba(150, 150, 150, 0.1);
    --transparentBackground-20: ${props =>
      props.theme === 'light' ? 'rgba(0,0,0,.10)' : 'rgba(0,0,0,.55)'};
    --transparentBackground-90: ${props =>
      props.theme === 'light' ? 'rgba(255,255,255,.9)' : 'rgba(0,0,0,.9)'};
    --textColor: ${props => (props.theme === 'light' ? 'black' : 'white')};
    --textDisabledColor: ${props =>
      props.theme === 'light' ? 'rgba(0,0,0,.5)' : 'rgba(255,255,255,.25)'};
    --textSecondaryColor: ${props =>
      props.theme === 'light' ? 'rgba(0,0,0,0.4)' : 'rgba(240,240,240,0.5)'};
    --whiteColor: white;
    --basicColor:${props => (props.theme === 'light' ? 'white' : 'black')};
    --greyColor: rgba(240,240,240,0.5);
    --primaryColor: ${props =>
      props.theme === 'light' ? variables.colors.blue : '#5c63ff'};
    --darkPrimaryColor: ${props =>
      props.theme === 'light' ? '#D5D6FE' : '#272a64'};
    --darkPrimaryColor-100: ${props =>
      props.theme === 'light' ? '#BBBCEA' : '#0B0E5B'};
    --secondaryColor: ${variables.colors.orange};
    --greenColor: ${variables.colors.green};
    --panelColor: ${props =>
      props.theme === 'light'
        ? variables.colors.dashboardLighterGrey
        : '#202020'};
    --panelColorTransparent: ${props =>
      props.theme === 'light'
        ? variables.colors.dashboardLighterGrey
        : '#202020'};
    --foregroundPanelColor: ${props =>
      props.theme === 'light' ? variables.colors.white : '#252525'};
    --borderColorDark: ${props =>
      props.theme === 'light' ? 'rgba(230,230,230,1)' : 'rgba(0, 0, 0, 1)'};
    --borderColorLight: ${props =>
      props.theme === 'light' ? 'rgba(230,230,230,1)' : 'rgba(60, 60, 60, 1)'};
    --panelBorderColor: ${props =>
      props.theme === 'light' ? 'rgba(230,230,230,1)' : 'rgba(0, 0, 0, 1)'};
      --filterInvert: ${props =>
        props.theme === 'light' ? 'invert(100%)' : 'invert(0)'};
  }

  .foregroundPanel {
    background: var(--foregroundPanelColor);
    border: 1px solid rgba(150, 150, 150, 0.25);
    color: ${props =>
      props.theme === 'light' ? 'rgba(50,50,50,1)' : variables.colors.white};
  }
  .backPanel {
    background: var(--panelBorderColor);
  }
  .panel {
    background: var(--panelColor);
    color: ${props =>
      props.theme === 'light' ? 'rgba(50,50,50,1)' : variables.colors.white};
  }
  .panel input {
    color: ${props =>
      props.theme === 'light' ? 'rgba(50,50,50,1)' : variables.colors.white};
    
  }
  .bordered {
    border-color: var(--panelBorderColor);
  }
  button,
  .button {
    background-color: var(--transparentBackground-10);
    color: var(--textColor);
    font-family: 'Roboto', sans-serif;
    :hover {
      background-color: var(--transparentBackground-20);
    }
  }
  .lightButton {
    background-color: rgb(245, 245, 245);
    color: rgba(0, 0, 0, 1);
    :hover {
      background-color: rgb(230, 230, 230, 1);
    }
  }
  button.tab {
    background-color: transparent;
    :hover{
      background-color: transparent;
      color: var(---primaryColor);
    }
  }

  button.blueBackground {
    color: ${variables.colors.white};
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    background-color: var(--primaryColor);
    :hover {
      background-color: ${variables.colors.highlightBlue};
    }
  }

  button.blueBackground.primary {
    background-color: ${variables.colors.white};
    color: var(--primaryColor);
    :hover {
      background-color: ${variables.colors.whiteHover};
    }
  }

  .dropdownMenu  * {
    pointer-events: all !important;
  }

  .blocker * {
    pointer-events: none;
  }

  .themableSVG {
    path,
    line {
      stroke: ${props =>
        props.theme === 'light'
          ? 'rgba(0, 0, 0, .6)'
          : 'rgba(255, 255, 255, 0.95)'};
    }
  }

  .inputField input:-webkit-autofill,
  .inputField input:-webkit-autofill:hover,
  .inputField input:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px var(--transparentBackground-10) inset;
    -webkit-text-fill-color: var(--textColor) !important;
  }

  .inputfieldtextarea,
  .inputField input,.inputField textarea {
    outline: none;
    background-color: var(--transparentBackground-10);
    color: var(--textColor);
    border: 1px solid var(--borderColorLight);
    border-radius: 5px;
  }

  .primary {
    background-color: var(--primaryColor);
    color: ${variables.colors.white};
    :hover {
      color: ${variables.colors.white};
      background-color: ${variables.colors.highlightBlue};
    }
  }

  .propInput {
    :hover {
      background-color: ${props =>
        props.theme === 'light'
          ? 'rgba(0, 0, 0, 0.05)'
          : 'rgba(255, 255, 255, 0.15)'};
    }
  }

  .dropdown {
    background-color: ${props =>
      props.theme === 'light'
        ? 'rgba(0, 0, 0, 0.05)'
        : 'rgba(255, 255, 255, 0.05)'};
  }

  .opened {
    background-color: ${props =>
      props.theme === 'light' ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.55)'};
  }

  .selected {
    background-color: var(--primaryColor);
    color: ${variables.colors.white};
  }
  .selected:hover {
    background-color: ${variables.colors.highlightBlue};
  }

  .checkbox {
    background-color: ${props =>
      props.theme === 'light'
        ? 'rgba(0, 0, 0, 0.05)'
        : 'rgba(255, 255, 255, 0.05)'};
    path {
      stroke: ${props =>
        props.theme === 'light'
          ? 'rgba(0, 0, 0, 1)'
          : 'rgba(255, 255, 255, 0.95)'};
    }
  }

  .scrollable-dark::-webkit-scrollbar,
  .scrollable-light::-webkit-scrollbar {
    width: 7px;
  }

  .scrollable-dark::-webkit-scrollbar-track,
  .scrollable-light::-webkit-scrollbar-track {
     background-color: transparent;
  }

  .scrollable-dark::-webkit-scrollbar-thumb,
  .scrollable-light::-webkit-scrollbar-thumb {
    background-color:var(--transparentGrey-10);
    border-radius: 50px;
  }

  .scrollable-light::-webkit-scrollbar-thumb:hover,
  .scrollable-dark::-webkit-scrollbar-thumb:hover {
    background-color:var(--transparentGrey-20);
  }
`;
